import {
  LoginOAuthParams,
  LoginOAuthResponse,
  OauthAEMConfig
} from '../models';
import { pkcCodeMock } from './login-oauth-service.mocks';

export const OAuthConfigMocks: OauthAEMConfig = {
  OAUTH2: '/as/authorization.oauth2?',
  RESPONSE_TYPE: 'response_type',
  RESPONSE_TYPE_VALUE: 'code',
  SCOPE: 'scope',
  SCOPE_VALUE: 'openid',
  MFA_SCOPE_VALUE: 'openid custapi.personaldata.read_only',
  RESPONSE_MODE: 'response_mode',
  RESPONSE_MODE_VALUE: 'pi.flow',
  CODE_CHALLENGE: 'code_challenge',
  CODE_CHALLENGE_METHOD: 'code_challenge_method',
  CODE_CHALLENGE_METHOD_VALUE: 'S256',
  OAUTH2_USER_CREDENTIALS: '/pf-ws/authn/flows/',
  OAUTH2_TOKEN: '/as/token.oauth2',
  OPEN_ID: '/idp/userinfo.openid',
  GRANT_TYPE: 'grant_type',
  AUTHORIZATION_CODE: 'authorization_code',
  CODE: 'code',
  CODE_VERIFIER: 'code_verifier',
  CLIENT_ID: 'client_id',
  CLIENT_ID_VALUE: 'deltacom',
  MFA_CLIENT_ID_VALUE: 'deltacom',
  MFA_ACTION: 'mfaAction',
  MFA_ACTION_VALUE: 'existingusersetup',
  MFA_ACTION_SSPR_VALUE: 'sspr',
  USERNAME_PASSWORD_REQUIRED: 'USERNAME_PASSWORD_REQUIRED',
  COMPLETED: 'COMPLETED',
  PROMPT: 'prompt',
  PROMPT_VALUE: 'login',
  LEVEL_OF_TRUST: 'level_of_trust',
  LEVEL_OF_TRUST_VALUE: '0',
  PERSISTENT_LOGIN_ENABLE: true,
  PERSISTENT_COOKIE_TIMER: 0.01875,
  ENABLE_PING_LOGOUT: true,
  IS_USER_REMEMBERED: 'IS_USER_REMEMBERED',
  ISSUER_PROD: 'https://signin-si.delta.com',
  LOG_OUT_URL: '/idp/startSLO.ping?TargetResource=',
  REMEMBERED_DEVICE_DETAILS: 'REMEMBERED_DEVICE_DETAILS',
  REMEMBERME_API_FLOW_ENABLE: true,
  SCOPE_VALUE_RM: 'openid',
  SHOULD_REMEMBER_USER: 'SHOULD_REMEMBER_USER',
  VERSION_PARAMETER: 'v',
  VERSION_PARAMETER_VALUE: '1',
  VERIFY_EMAIL_MFA: 'verifyemailmfa',
  VERIFY_EMAIL_MFA_VALUE: 'yes',
  ISSUER_WIFI_PORTAL: 'https://signin-si.delta.com',
  RESUME: 'RESUME',
  PING_DOMAIN: 'https://signin-si.delta.com',
  PING_FLOW_ENABLED: true,
  BFF_CODES_TO_IGNORE: "['22', '127', '30', '51']",
  NU_TRAVEL_URL: [
    'https://businessmanagement.delta.com/',
    'https://deltauat-web01.nutravel.com/'
  ],
  IS_EMAIL_ALLOWED: false,
  ACCOUNT_RECOVERY_FLOW_ENABLED: true,
  AWS_ACCOUNT_RECOVERY_FLOW_ENABLED: true,
  BAU_URLS: [
    'delta.com/mytrips/',
    'delta.com/vacations/',
    'delta.com/contactus/',
    'delta.com/buygftxfer/',
    'delta.com/skyclub/',
    'delta.com/cartalacarte/',
    'delta.com/seat/'
  ],
  COOKIE_DOMAIN: ';domain=.delta.com; path=/',
  COOKIE_DOMAIN_VALUE: '.delta.com',
  LOGIN_URLS: [
    '/login/loginPage',
    '/user-login/loginPage',
    '/user-login/forgotLogin',
    '/user-login/resetPassword',
    '/user-login/createPassword',
    '/user-login/loginHelp',
    '/user-login/addSQA',
    '/user-login/addAddress',
    '/user-login/addEmail'
  ],
  REDIRECTION_URLS: [
    '/skymiles/login',
    '/skymiles/forgotLogin/',
    '/skymiles/resetPassword/',
    '/skymiles/loginHelp/',
    '/skymiles/addSQA',
    '/skymiles/addAddress',
    '/skymiles/addEmail'
  ],
  PHASE_ONE_URLS: [
    '',
    '/us/en/need-help/overview',
    '/us/en/need-help/support-skymiles',
    '/us/en/need-help/support-other-information'
  ],
  LOGIN_PICKER: '/skymiles/profilePickerPage',
  LOGIN_PICKER_STANDALONE: '/skymiles/profilePickerPage',
  DELETE_STANDALONE_COOKIE: true,
  MAKE_PE_CALL: true,
  ENABLE_NEW_PROFILE_SELECTOR: true,
  EAM_OUTAGE_ERROR_CODE_IGNORE: ['200', '400', '404'],
  ENABLE_NEW_PERSISTENT_LOGIN: true,
  REGISTER_SW_URL: '/skymiles/login-sw.js?3=3',
  FTWR_LOGIN_MODAL_COOKIE_AGE: 30,
  LOGIN_STANDALONE_PAGE_URL: '/skymiles/login',
  REDIRECT_REFRESH_URLS: ['/content/www/acs/landing.html'],
  ORION_FLYOUT: true,
  CLEAR_CKO_COOKIE: true,
  PROFILE_PAGE_URL: '/myprofile',
  MFA_FLOW: true,
  FLY_DELTA_POLLING_TIMER: 5000,
  VERIFICATION_SCREEN_TIMER: 3000,
  ONE_TIME_PASSCODE_TIMER: 600,
  NEW_RESET_PASSWORD_FLOW: true,
  MFA_URLS: ['skymiles/login?mfa=true'],
  APP_SAVED_SEARCH_API_GRAPHQL:
    'https://customer-api-si.delta.com/profile/graphql',
  SAVED_SEARCH_GRAPHQL_CLIENT_ID_VALUE: 'h2TdfxWn7u3KpJauQLDmihcZ',
  SAVED_SEARCH_GRAPHQL_SCOPE_VALUE: 'custapi.saved.search.read_only',
  FLY_DELTA_POLLING_APP_NAME: 'Fly Delta - Beta Build',
  FLY_DELTA_COOL_DOWN_TIME: 121,
  MFA_SETUP_LATER_TIMER: 30,
  REGISTRATION_RETRY_COUNT: 2,
  REGISTRATION_RETRY_TIMER: 3000,
  DISABLE_SQA_SCREEN: true,
  TOKEN_HEADER: true,
  MFA_TIMEOUT: 10000,
  LOGIN_TIMEOUT: 30000,
  LOGIN_RETRY_COUNT: 2,
  LOGIN_RETRY_TIMER: 3000,
  MFA_STUDIO_CONFIG_ID: 'c9fe9f7a-2ee5-4889-b753-5913244b71b0',
  REMAINING_OTP_ATTEMPT: 5,
  REFRESH_TOKEN_TIME: 300000,
  RESTRICT_AUTH_CALLS_URL: ['/skymiles/login'],
  PUSH_NOTIFICATION_TIMER: 60,
  ERROR_428: true,
  MAKE_SERVER_PE_CALL: false,
  HEADER_CLIENT_ID_VALUE: 'RPhZFaEniDwvg8usGNxEyzT2',
  GET_SAVED_TRIPS_AWS_API_FLAG: true,
  TRIPS_API_AWS: true,
  PROFILE_BFF_AWS: true,
  TRIP_SEARCH_AWS: true,
  CASE_STATUS_AWS: true,
  NGC_COOKIE_BANNER_ENABLE: false,
  POST_CORPORATE_ID_FLAG: true
};

export const LoginOAuthMocks: LoginOAuthParams = {
  oauthConfig: OAuthConfigMocks,
  pkceCode: pkcCodeMock
};

export const IsUserRememberResponseMock: LoginOAuthResponse = {
  id: 'pslt2Z7Vv7',
  pluginTypeId: '9I-5UWXhraTpoYHL5DJMlw',
  status: 'IS_USER_REMEMBERED'
};

export const CompletedResponseMock: LoginOAuthResponse = {
  id: 'pslt2Z7Vv7',
  pluginTypeId: '9I-5UWXhraTpoYHL5DJMlw',
  status: 'COMPLETED'
};

export const InvalidAuthResponseMock: LoginOAuthResponse = {
  id: 'pslt2Z7Vv7',
  pluginTypeId: '9I-5UWXhraTpoYHL5DJMlw',
  status: ''
};

export const UserNamePasswordRequiredResponseMock: LoginOAuthResponse = {
  id: 'pslt2Z7Vv7',
  pluginTypeId: '9I-5UWXhraTpoYHL5DJMlw',
  status: 'USERNAME_PASSWORD_REQUIRED'
};
